import { render, staticRenderFns } from "./BookingAttachmentList.vue?vue&type=template&id=7ef55364"
import script from "./BookingAttachmentList.vue?vue&type=script&lang=ts"
export * from "./BookingAttachmentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports